function initCartPageTracking() {
    function formatProductData(productData, index) {
        const {sku, product_title, vendor, product_type, variant_title, price, quantity } = productData
        return {
            item_id: sku,
            item_name: product_title,
            affiliation: Shopify.shop,
            currency: Shopify.currency.active,
            discount: trackingFormatPrice(trackingGetProductDiscount(productData)),
            index,
            item_brand: vendor,
            item_category: product_type,
            item_list_id: "all",
            item_list_name: "All",
            item_variant: variant_title,
            price: trackingFormatPrice(price),
            quantity: quantity
        }
    }

    function getCartProductData() {
        const productEles = [...document.querySelectorAll('.js-line-item-remove [data-tracking-product]')]
        const items = productEles.map((ele, index) => formatProductData(JSON.parse(ele.innerText), index));
        return items;
    }
    function handleViewCart() {
        const data = getCartProductData();
        const value = trackingFormatPrice(data.reduce((previous, current) => {
            return previous + +current.price
        }, 0), 1)
        pushToDataLayer("view_cart", data, Shopify.currency.active, value)

    }
    handleViewCart();
}

initCartPageTracking()